import * as httpx from "httpx"
import * as images from "."
import { ImageEvent, ImageSearchResponseItem } from "brandguard/brandguard.image_pb"

export const agree = (
	item: ImageSearchResponseItem & { event: ImageEvent },
	...options: httpx.option[]
): Promise<ImageSearchResponseItem> => {
	return images.uploads.review(item.event.id, item.event.brand_id, ...options)
}

export const disagree = (
	item: ImageSearchResponseItem & { event: ImageEvent },
	...options: httpx.option[]
): Promise<ImageSearchResponseItem> => {
	return images.uploads.review(item.event.id, item.event.brand_id, ...options)
}
